import React from 'react'
import FormSF from './FormSF'
import ModalUI from '../layout/ModalUI'

const ModalFormUI = ({context, messageList, titleMessageKey, titleLabel, isOpen, children,
    // event handlers
    onAfterOpen, onRequestClose,
    // form stuff
    buttonLabel, cancelLabel,
    buttonMessageKey, cancelMessageKey, successMsg, errorList, setErrorList, onSubmit, busy
  }) =>
  <ModalUI
    context={context}
    messageList={messageList}
    titleMessageKey={titleMessageKey}
    titleLabel={titleLabel}
    isOpen={isOpen}
    // event handlers
    onAfterOpen={onAfterOpen}
    onRequestClose={onRequestClose}
  >
    <FormSF context={context} buttonLabel={buttonLabel} cancelLabel={cancelLabel}
      messageList={messageList} buttonMessageKey={buttonMessageKey} cancelMessageKey={cancelMessageKey}
      successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      onSubmit={onSubmit} onCancel={onRequestClose} busy={busy}>
      {children}
    </FormSF>
  </ModalUI>

export default ModalFormUI
